import http from "../../http";

const dimension = {
    selectAuthorizationDimensionList(r) {
        return  http.get("/gateway/org/pc/dimension/selectAuthorizationDimensionList",r )
    },

}
export default dimension
